<template>
  <div :class="containerClassName">
    <slot name="label" :id="id" :label="label" :required="required">
      <label :for="id" v-if="!hideLabel">{{label}}<span v-if="required"> *</span></label>
    </slot>

    <div class="input-container" :class="inputContainerClasses" :data-symbol="symbol">
      <label v-if="inputLabel" class="label-input-title" :title="inputLabel">{{inputLabel | truncate(35)}}</label>
      <input
        type="text"
        autocomplete="off"
        :id="id"
        :name="name"
        :value="value"
        :class="inputClasses"
        :disabled="disabled"
        :readonly="readonly"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @keydown="onKeydown"
        @input="onInput"
        @blur="onBlur"
        @focus="onFocus"
        @paste="onPaste"
      >
      <span v-if="disabled" class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-disabled"></use></svg></span>
      <span class="form-error-label" v-if="errors.has(name)">
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
        {{ customErrorMessage ? customErrorMessage : errors.first(name) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheDecimalInput',
  inject: [
    '$validator'
  ],
  props: {
    pickerOptions: {
      type: Array,
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    customErrorMessage: {
      type: String,
      default: ''
    },
    containerClassName: {
      type: String,
      default: 'cell large-12'
    },
    id: {
      type: String,
      default: function () {
        return 'decimal-input-id-' + this._uid
      }
    },
    name: {
      type: String,
      default: null
    },
    value: {
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    symbol: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: String,
      default: null
    },
    disabled: {
      type: [Boolean, Number],
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    inputLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    inputClasses: function () {
      let cls = []

      // Add the main class name
      cls.push(this.className)

      // Add disabled
      if (this.disabled) {
        cls.push('disabled')
      }

      // Add readonly
      if (this.readonly) {
        cls.push('readonly')
      }

      // Add error
      if (this.errors.has(this.name)) {
        cls.push('error')
      }

      return cls
    },
    inputContainerClasses: function () {
      let cls = []

      if (this.errors.has(this.name)) {
        cls.push('form-error')
      }

      if (this.disabled) {
        cls.push('disabled')
      }

      if (this.symbol) {
        cls.push('symbol-glyph')
      } else if (this.inputLabel) {
        cls.push('label-input')
      } else {
        cls.push('text')
      }

      return cls
    }

  },
  methods: {
    onPaste: function (e) {
      var vm = this

      // Do some replacing on paste
      setTimeout(function () {
        // Replace anything that is not 0-9, also prepend plus sign if have that
        e.target.value = e.target.value
          .replace(/,/, '.')
          .replace(/[^\d.-]/g, '')
          .replace(/(?!^)-/g, '')
          .replace('.', '%FD%')
          .replace(/\./g, '')
          .replace(/%FD%(0+)?$/, '')
          .replace('%FD%', '.')

        e.preventDefault()
        vm.onInput(e)
      })
    },
    onKeydown: function (e) {
      let k = e.keyCode

      // console.log('Keycode: ', k)

      // Pressed ENTER, TAB, BACKSPACE, <-, -> or 0 - 9, inc num pad
      if (e.metaKey || (k === 13 || k === 8 || k === 9 || k === 37 || k === 39) || (k >= 48 && k <= 57) || (k >= 96 && k <= 105)) {
        return true
      }

      // 110 = , (keypad)
      // 188 / 44 = ,
      // 190 / 46 = .

      // Replace comma with dot
      if (!e.target.value && (k === 188 || k === 110)) {
        e.target.value = '.'
      }

      // If comma or dot pressed
      if (k === 110 || k === 188 || k === 190) {
        // Already have a comma or dot?
        if (e.target.value.match(/(\.|,)+/g)) {
          e.preventDefault()
        } else {
          // Else ok, but replace comma with dot. Superfast timeout needed
          setTimeout(function () {
            e.target.value = e.target.value.replace(/,/, '.')
          }, 5)

          return true
        }
      }

      e.preventDefault()
    },
    onInput (e) {
      this.$emit('input', e.target.value)
    },
    onBlur (e) {
      this.$emit('blur')
    },
    onFocus (e) {
      this.$emit('focus')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Inputs/TheDecimalInput.vue